import React from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { authStore } from '@/stores/AuthStore';
import { ROUTES } from '@/constants/routes';
import './ImpersonationBanner.css';

const ImpersonationBanner: React.FC = observer(() => {
  const navigate = useNavigate();
  const user = authStore.user;

  if (!user?.impersonation) {
    return null;
  }

  const scName = user.impersonated_service_center_name || 'сервисный центр';

  const handleLogout = () => {
    authStore.logout();
    navigate(ROUTES.AUTH_PHONE, { replace: true });
  };

  return (
    <div className="impersonation-banner" role="status" data-testid="impersonation-banner">
      <span className="impersonation-banner__text">
        Режим суперадмина: вы работаете в панели «{scName}»
      </span>
      <button
        type="button"
        className="impersonation-banner__logout"
        onClick={handleLogout}
      >
        Выйти
      </button>
    </div>
  );
});

ImpersonationBanner.displayName = 'ImpersonationBanner';
export default ImpersonationBanner;
